export const BlockCNStatus = {
  BLOCKED: 'BLOCKED',
  UNBLOCKED: 'UNBLOCKED',
  RTO: 'RTO'
};
export const BlockCNMessages = {
  GET_FAIL: 'Could not fetch blocked CNs',
  ADD_FAIL: 'Add to Block List failed',
  SUCESS: 'CN status changed successfully',
  GET_UNBLOCKED_FAIL: 'Could not fetch unblocked CNs'
};

export const RTOCNMessages = {
  RTO_FAIL: 'Failure to mark consignment RTO'
};

export const UnblockCNMessages = {
  INVALID_CNOTE: 'CN(s) not found',
  SUCCESS: 'CN(s) unblocked',
  CN_BLOCKER_NOT_FOUND_FOR_GIVEN_REASON:
    'CN(s) are already unblocked for the reason.',
  RTO_BLOCKED: 'CN(s) blocked under RTO and hence cannot be unblocked',
  FAIL_UNBLOCK: 'Failed to unblock CN(s)'
};

export const RtoUnblockDashboardStatuses = {
  RTO_CN: 'Consignee will not accept consignment.',
  UNBLOCKED_CN: 'Consignee will accept the consignment.',
  BLOCKED_CN: 'Damage or Pilferage'
};

export const IncompleteCnConstants = {
  createCn: 'createcnote'
};
